import { BASE_URL, UPLOAD_IMAGES } from "./constants";
const serverUrl = BASE_URL?.endsWith("/")? BASE_URL.slice(0, -1):BASE_URL;
export const IES= {
    NAME:"N/A",
    NUIT:"N/A",
    CODE:"N/A",
    EMAIL:"N/A",
    PHONE_NUMBER:"N/A",
    ENROLLMENT_DEPARTAMENT_NAME:"N/A",
    LOGO:`${serverUrl}${UPLOAD_IMAGES}/logo`,
    BACKGROUND:`${serverUrl}${UPLOAD_IMAGES}/background`,
    FAVICON:`${serverUrl}${UPLOAD_IMAGES}/favicon`,
    COUNTRY:"N/A",
    CITY:"N/A",
};